'use strict';
module.exports = function (obj) {
	var keys = Object.keys(obj);
	var ret = [];

	for (var i = 0; i < keys.length; i++) {
		ret.push(obj[keys[i]]);
	}

	return ret;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/object-values/index.js
// module id = 279
// module chunks = 0